import { Injectable } from '@angular/core';
import { NavigationConfigService } from './navigation-config.service';
/**
 * Roles whose users pick an entity from the header dropdowns instead of being tied
 * to a single one. Shared with LayoutComponent, which blanks the header entity label
 * for them. Distinct from the much wider sidebar role list in that component.
 */
export const ENTITY_DROPDOWN_ROLES = ['HMGR', 'HAPPR', 'HEXCT', 'HRL', 'HRN', 'HRLN'];

declare global {
  interface Window {
    plausible?: (eventName: string, options?: { props?: Record<string, any> }) => void;
  }
}
@Injectable({
  providedIn: 'root'
})
export class PlausibleAnalyticsService {
  constructor(private navConfigService: NavigationConfigService) { }

  trackPageview(currentRoute: string, userRole: string): void {

    if (!ENTITY_DROPDOWN_ROLES.includes(userRole)) {
      return;
    }

    // Role-scoped route list from the server-side navigation config cache
    // (replaces the static ValidRouts.ts import). Null only before the route
    // guard's first fetch completes — skip tracking in that window.
    const navConfig = this.navConfigService.getConfigSync();

    if (!navConfig) {
      return;
    }

    const isValidRoute = navConfig.routes.includes(currentRoute);

    if (!isValidRoute) {
      return;
    }

    if (typeof window !== 'undefined' && window.plausible) {
      window.plausible('pageview', {
        props: { route: currentRoute, role: userRole }
      });
    }
  }

  trackEvent(eventName: string, props?: Record<string, any>): void {
    if (typeof window !== 'undefined' && window.plausible) {
      window.plausible(eventName, { props });
    }
  }
}